import { ReactNode } from 'react';

import {
  Banner,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { ContainerColorVariants } from '@beeline/design-system-react/types/components/Banner/Banner.types';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import styles from './styles.module.scss';

type Props = { description: string | undefined; color: ContainerColorVariants };
export function ServiceBanner({ description, color }: Props): ReactNode {
  if (!description) return null;

  return (
    <div className={styles.bannerContainer}>
      <Banner
        className={styles.banner}
        color={color}
        iconName={Icons.WarningCircled}
        title={<Typography variant='body3'>{description}</Typography>}
      />
    </div>
  );
}
